

"use client"

import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import { root_url } from "../../services/API"
import moment from "moment"
import Header from "../../components/Header"
import NutriationTab from "../../components/Nutriation"

import {
  Button,
  TextField,
  CardContent,
  CardHeader,
  Box,
  Typography,
  Container,
  FormControl,
  FormLabel,
  Select as MuiSelect,

  RadioGroup,
  Radio,
  FormControlLabel,
  Switch,
  IconButton,
  Tabs,
  Tab,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select as MUISelect,
  Chip,
  Grid,
  InputAdornment,
} from "@mui/material"
import Select from "react-select"
import makeAnimated from "react-select/animated"
import DeleteIcon from "@mui/icons-material/Delete"
import AddIcon from "@mui/icons-material/Add"
import RefreshIcon from "@mui/icons-material/Refresh"
import SaveIcon from "@mui/icons-material/Save"
import DragIndicatorIcon from "@mui/icons-material/DragIndicator"
import CloseIcon from "@mui/icons-material/Close"
import Toast from "../../components/Toast"
import AddOnsTab from "../../components/AddOn"
import Veg from "../../assets/Veg.png"
import NonVeg from "../../assets/Non-Veg.png"
import Jain from "../../assets/Jain.png"
import EggFood from "../../assets/Egg.png"
import Drinks from "../../assets/Drinks.png"

const animatedComponents = makeAnimated()
const scrollbarHide = {
  "&::-webkit-scrollbar": {
    display: "none",
  },
  scrollbarWidth: "none",
  "-ms-overflow-style": "none",
}

const dropdownStyles = {
  backgroundColor: "#02111B",
  color: "#FFC857",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.23)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#FFC857",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#FFC857",
  },
}

const menuItemStyles = {
  backgroundColor: "#02111B",
  color: "#FFC857",
  "&:hover": {
    backgroundColor: "rgba(255, 200, 87, 0.08)",
  },
}

class UpdateMenuScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // Menu details
      id: "",
      full_url: "",
      status: false,
      brand_name: "",
      menu_name: "",
      menu_image: "",
      updateLoading: false,
      updateAndNextLoading: false,
      menu_type: "veg",
      menu_price: "",
      menu_description: "",
      food_availabel: "all-day",
      start_time: "",
      end_time: "",
      menu_available_time_slot: "",

      // Categories
      category: [],
      selectedCategories: [],
      category_ids: [],

      // UI state
      activeTab: 0,
      attributeTabIndex: 0,
      loading: false,
      toast: { open: false, message: "", severity: "success" },

      // Space wise menu
      spaceData: [],
      basePrice: 0,

      // Attributes
      attributes: [],
      newAttributeName: "",
      newAttributeValue: "",
      attributeValues: [],
      editingAttributeId: null,

      // Variations
      variations: [],

      // Add-ons
      addOnGroups: [],
      isAddGroupOpen: false,
      isAddItemOpen: false,
      currentGroupId: null,
      newGroup: {
        name: "",
        required: false,
        multiple: false,
        min_select: 0,
        max_select: 1,
        status: true,
      },
      newAddOn: {
        name: "",
        price: "",
        status: true,
      },
       loadedTabs: new Set(),
    }
    console.log("props in UpdateMenuScreen", props)
  }
  getSlots = (current_start_time = null) => {
    if (current_start_time) {
      current_start_time = moment(current_start_time, ["h:mm A"]).format("HH:mm:ss")
    }

    const start_time = current_start_time ?? "00:00:00"
    const end_time = "23:59:59"

    const slots = []

    const selectedDate = moment().format("YYYY-MM-DD")

    const start = moment(`${selectedDate} ${start_time}`)

    if (start_time) start.add(30, "minutes")

    const end = moment(`${selectedDate} ${end_time}`)

    while (start.isBefore(end)) {
      slots.push({
        label: start.format("hh:mm A"),
        value: start.format("hh:mm A"),
      })
      start.add(30, "minutes")
    }

    return slots
  }

  addTimeSlot = () => {
    if (!this.state.currentStartTime || !this.state.currentEndTime) return;

    // Convert to 24-hour format
    const start24 = moment(this.state.currentStartTime, "hh:mm A").format("HH:mm:ss");
    const end24 = moment(this.state.currentEndTime, "hh:mm A").format("HH:mm:ss");

    this.setState(prevState => ({
      timeSlots: [
        ...prevState.timeSlots,
        {
          start_time: start24,
          end_time: end24,
          display_start: this.state.currentStartTime,
          display_end: this.state.currentEndTime
        }
      ],
      currentStartTime: '',
      currentEndTime: ''
    }));
  };

  removeTimeSlot = (index) => {
    this.setState(prevState => ({
      timeSlots: prevState.timeSlots.filter((_, i) => i !== index)
    }));
  };
  // Toast handling
  showToast = (message, severity) => {
    this.setState({ toast: { open: true, message, severity } })
  }

  getCategory = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.listCategory(this.props.selectedHotelId.id))
    if (status == "success") {
      this.setState({
        category: data.data.map((item) => ({
          value: item.id,
          label: item.category_name,
        })),
      })
    } else this.showToast(message, "error")
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") return
    this.setState({ toast: { ...this.state.toast, open: false } })
  }
  handleFoodAvailableChange = (event) => {
    this.setState({ menu_available_time_slot: event.target.value })
  }


  handleStartTimeChange = (event) => {
    this.setState({ start_time: event.target.value })
  }

  handleEndTimeChange = (event) => {
    this.setState({ end_time: event.target.value })
  }
  // Tab handling
 handleTabChange = (event, newValue) => {
  this.setState({ activeTab: newValue });

  // Only fetch data if the tab hasn't been loaded before
  if (!this.state.loadedTabs.has(newValue)) {
    const fetchOperations = {
      1: this.fetchSpaceWiseMenu,
      2: this.fetchAttributes,
      3: this.fetchVariations,
      4: this.fetchAddons,
      5: null // Nutrition tab might have its own loading mechanism
    };

    if (fetchOperations[newValue]) {
      fetchOperations[newValue]().then(() => {
        // Mark the tab as loaded after successful fetch
        this.setState(prevState => ({
          loadedTabs: new Set(prevState.loadedTabs).add(newValue)
        }));
      });
    }
  }
};

  handleAttributeTabChange = (event, newValue) => {
    this.setState({ attributeTabIndex: newValue })
  }
  handleNutritionSuccess = () => {
    this.setState({ activeTab: 2 })
  }
  // Initial data loading
 componentDidMount() {
    // Check if hotel slug matches
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return; 
    }

    this.getMenuDetail(this.props.match.params.id);
    this.getCategory();
    this.setState({ loadedTabs: new Set([0]) });
}

  // Fetch categories for dropdown
  fetchCategoriesForDropdown = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.listCategoryForDropdown(this.props.selectedHotelId.id),
    )

    if (status === "success") {
      this.setState({ category: data })
    } else {
      this.showToast(message, "error")
    }
  }

  // Get menu details
getMenuDetail = async (id) => {
    this.setState({ loading: true });

    const { status, message, data } = await API(this, "get", URL_PATH.menuDetails(id));
    console.log("data in menu update", data);
    console.log("category params slug", this.props.match.params.categorySlug);

    if (status === "success") {
        // Normalize all slugs
        const dataCategorySlug = data.category_slug?.toLowerCase()?.trim();
        const paramsCategorySlug = this.props.match.params.categorySlug?.toLowerCase()?.trim();
        const dataMenuSlug = data.menu_slug?.toLowerCase()?.trim();
        const paramsMenuSlug = this.props.match.params.menuSlug?.toLowerCase()?.trim();

        // Check both possible combinations since they might be swapped
        const slugsMatch = 
            (dataCategorySlug === paramsCategorySlug && dataMenuSlug === paramsMenuSlug) ||
            (dataCategorySlug === paramsMenuSlug && dataMenuSlug === paramsCategorySlug);

        if (!slugsMatch) {
            console.log("Slug mismatch detected:");
            console.log("Data category slug:", dataCategorySlug);
            console.log("Params category slug:", paramsCategorySlug);
            console.log("Data menu slug:", dataMenuSlug);
            console.log("Params menu slug:", paramsMenuSlug);
            
            this.showToast("URL doesn't match the menu item", "error");
            this.props.history.push(routes.admin.menu.root(this.props.hotels[0]?.hotel_slug));
            return;
        }

        const current_category_ids = data.hotel_menu_category.map((item) => ({
            value: item.id,
            label: item.category_name,
        }));

        // Parse existing time slots
        let existingSlots = [];
        try {
            if (data.available_data && data.available_data !== "null") {
                const parsedData = JSON.parse(data.available_data);
                if (Array.isArray(parsedData)) {
                    existingSlots = parsedData.map(slot => ({
                        start_time: slot.start_time,
                        end_time: slot.end_time,
                        display_start: moment(slot.start_time, "HH:mm:ss").format("hh:mm A"),
                        display_end: moment(slot.end_time, "HH:mm:ss").format("hh:mm A")
                    }));
                }
            }
        } catch (e) {
            console.error("Error parsing available_data", e);
        }

        this.setState({
            id: data.id,
            status: data.status,
            brand_name: data.brand_name,
            menu_name: data.menu_name,
            menu_type: data.menu_type,
            menu_image: data.menu_image,
            menu_price: data.menu_price,
            menu_description: data.menu_description,
            category_ids: current_category_ids,
            selectedCategories: current_category_ids,
            basePrice: Number.parseFloat(data.menu_price) || 0,
            timeSlots: existingSlots,
            menu_available_time_slot: data.menu_available_time_slot || '',
            food_availabel: data.menu_available_time_slot === "allday" ? "all-day" : "slot-wise",
            full_url: data.full_url,
        });
    } else {
        this.showToast(message, "error");
        this.props.history.push(routes.admin.menu.root(this.props.hotels[0]?.hotel_slug));
    }

    this.setState({ loading: false });
};
  handleAddAttributeValue = () => {
    const value = this.state.newAttributeValue.trim();
    if (value && !this.state.attributeValues.includes(value)) {
      this.setState((prevState) => ({
        attributeValues: [...prevState.attributeValues, value],
        newAttributeValue: ""
      }));
    }
  };
  handleRemoveAttributeValue = (valueToRemove) => {
    this.setState((prevState) => ({
      attributeValues: prevState.attributeValues.filter(val => val !== valueToRemove)
    }));
  };

  // Update menu
  update = async (shouldGoToNextTab = false) => {
    this.setState({ loading: true });

    const formdata = new FormData(document.getElementById("hotelForm"));
    formdata.append("hotel_id", this.props.selectedHotelId.id);

    if (this.state.category_ids.length === 0) {
      this.showToast("Please select category", "error");
      this.setState({ loading: false });
      return;
    }

    formdata.append("category_id", `[${this.state.category_ids.map((item) => '"' + item.value + '"')}]`);
    formdata.append("status", this.state.status ? true : false);
    formdata.append("menu_available_time_slot", this.state.menu_available_time_slot);

    // Handle time slots for multiple availability
    if (this.state.menu_available_time_slot === "multiple") {
      if (this.state.timeSlots.length === 0) {
        this.showToast("Please add at least one time slot", "error");
        this.setState({ loading: false });
        return;
      }

      // Append all time slots to formdata
      this.state.timeSlots.forEach((slot, index) => {
        formdata.append(`available_data[${index}][start_time]`, slot.start_time);
        formdata.append(`available_data[${index}][end_time]`, slot.end_time);
      });
    }

    const headers = {
      "Content-Type": "multipart/form-data",
    };
    try {
      const { status, message } = await API(
        this,
        "post",
        URL_PATH.updateMenu(this.props.match.params.id),
        formdata,
        headers
      );

      if (status === "success") {
        this.showToast(message, "success");
        if (shouldGoToNextTab) {
          this.setState({ activeTab: 1 }, () => {
            this.fetchSpaceWiseMenu();
          });
        }
      } else {
        this.showToast(message, "error");
      }
    } catch (error) {
      this.showToast("An error occurred while updating the menu", "error");
      console.error("API Error:", error);
    }

    // Reset both loading states
    this.setState({
      updateLoading: false,
      updateAndNextLoading: false
    });
  };

    updateSave = async (shouldGoToNextTab = false) => {
    this.setState({ loading: true });

    const formdata = new FormData(document.getElementById("hotelForm"));
    formdata.append("hotel_id", this.props.selectedHotelId.id);

    if (this.state.category_ids.length === 0) {
      this.showToast("Please select category", "error");
      this.setState({ loading: false });
      return;
    }

    formdata.append("category_id", `[${this.state.category_ids.map((item) => '"' + item.value + '"')}]`);
    formdata.append("status", this.state.status ? true : false);
    formdata.append("menu_available_time_slot", this.state.menu_available_time_slot);

    // Handle time slots for multiple availability
    if (this.state.menu_available_time_slot === "multiple") {
      if (this.state.timeSlots.length === 0) {
        this.showToast("Please add at least one time slot", "error");
        this.setState({ loading: false });
        return;
      }

      // Append all time slots to formdata
      this.state.timeSlots.forEach((slot, index) => {
        formdata.append(`available_data[${index}][start_time]`, slot.start_time);
        formdata.append(`available_data[${index}][end_time]`, slot.end_time);
      });
    }

    const headers = {
      "Content-Type": "multipart/form-data",
    };
    try {
      const { status, message } = await API(
        this,
        "post",
        URL_PATH.updateMenu(this.props.match.params.id),
        formdata,
        headers
      );

      if (status === "success") {
        this.showToast(message, "success");
         setTimeout(() => {
        this.props.history.push(routes.admin.menu.root(this.props.hotels[0]?.hotel_slug))
      }, 1000)
        if (shouldGoToNextTab) {
          this.setState({ activeTab: 1 }, () => {
            this.fetchSpaceWiseMenu();
          });
        }
      } else {
        this.showToast(message, "error");
      }
    } catch (error) {
      this.showToast("An error occurred while updating the menu", "error");
      console.error("API Error:", error);
    }

    // Reset both loading states
    this.setState({
      updateLoading: false,
      updateAndNextLoading: false
    });
  };

  // Handle image upload
  handleImageUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      this.setState({ menu_image: URL.createObjectURL(file) })
    }
  }

  // Handle image delete
  handleImageDelete = () => {
    this.setState({ menu_image: "" })
  }

  // SPACE WISE MENU FUNCTIONS

  // Fetch space wise menu data
  fetchSpaceWiseMenu = async () => {
    try {
      const requestData = {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
      }

      console.log("requestDatarequestData", requestData, URL_PATH.getSpacesWisePrice)

      const { status, message, area_prices } = await API(this, "post", URL_PATH.getSpacesWisePrice, requestData)
      console.log("Hellow", status, message, area_prices)
      if (status) {
        // Initialize all final prices with the base price if they're not set
        const updatedSpaceData = area_prices.map((space) => {
          if (!space.area_final_price) {
            return {
              ...space,
              area_final_price: this.state.basePrice,
            }
          }
          return space
        })

        this.setState({ spaceData: updatedSpaceData })
      } else {
        this.showToast(message, "error")
      }
    } catch (error) {
      this.showToast("Failed to fetch spaces data", "error")
    }
  }

  // Handle price type change
  handlePriceTypeChange = (index, value) => {
    const updatedSpaceData = [...this.state.spaceData]
    updatedSpaceData[index].area_price_type = value

    // Reset value when switching types for cleaner UX
    updatedSpaceData[index].area_type_wise_value = 0
    updatedSpaceData[index].area_final_price = this.state.basePrice

    this.setState({ spaceData: updatedSpaceData })
  }

  // Handle price value change
  handlePriceValueChange = (index, value) => {
    const updatedSpaceData = [...this.state.spaceData]
    const numericValue = Number.parseFloat(value) || 0
    updatedSpaceData[index].area_type_wise_value = numericValue

    // Calculate final price
    this.calculateFinalPrice(updatedSpaceData, index)

    this.setState({ spaceData: updatedSpaceData })
  }

  // Calculate final price
  calculateFinalPrice = (spaceData, index) => {
    const space = spaceData[index]
    const basePrice = this.state.basePrice

    if (space.area_price_type === "fix") {
      const additionalAmount = Number.parseFloat(space.area_type_wise_value) || 0
      space.area_final_price = additionalAmount === 0 ? basePrice : basePrice + additionalAmount
    } else {
      // Calculate percentage of basePrice
      const percentageValue = Number.parseFloat(space.area_type_wise_value) || 0
      space.area_final_price = percentageValue === 0 ? basePrice : basePrice + (basePrice * percentageValue) / 100
    }
  }

  // Handle status change
  handleStatusChange = (index, checked) => {
    const updatedSpaceData = [...this.state.spaceData]
    updatedSpaceData[index].area_status = checked
    this.setState({ spaceData: updatedSpaceData })
  }

  // Save space wise menu
  handleSaveSpaces = async () => {
    try {
      this.setState({ loading: true })

      // Format the data according to the required structure
      const formattedData = {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        area_prices: this.state.spaceData.map((space) => ({
          area_name: space.area_name,
          area_price_type: space.area_price_type,
          area_type_wise_value: space.area_type_wise_value,
          area_status: space.area_status,
        })),
      }

      const { status, message } = await API(this, "post", URL_PATH.saveSpacesWisePrice, formattedData)

      if (status) {
        this.showToast("Space data saved successfully", "success")
        // Move to next tab
        this.setState({ activeTab: 2 }, () => {
          this.fetchAttributes()
        })
      } else {
        this.showToast(message || "Failed to save space data", "error")
      }

      this.setState({ loading: false })
    } catch (error) {
      this.showToast("Failed to save space data", "error")
      this.setState({ loading: false })
    }
  }

  // ATTRIBUTES FUNCTIONS

  // Fetch attributes
  fetchAttributes = async () => {
    try {
      const { status, message, data } = await API(this, "get", URL_PATH.getAttributes(this.props.match.params.id));

      if (status && data.length > 0) {
        const attributeData = data[0].attribute_data;

        this.setState({
          attributes: attributeData.map((attr) => ({
            id: attr.attribute_id,
            name: attr.attribute_name,
            values: attr.attribute_value,
            visible: true,
            used_for_variations: true,
          })),
        });
      } else {
        // this.showToast(message || "No attributes added for this item", "error");
      }
    } catch (error) {
      // this.showToast("Failed to fetch attributes", "error");
    }
  };


  handleAddAttribute = async () => {
    if (this.state.newAttributeName.trim() === "" || this.state.attributeValues.length === 0) {
      this.showToast("Attribute name and at least one value are required", "error");
      return;
    }

    const newAttribute = {
      id: Date.now().toString(),
      name: this.state.newAttributeName,
      values: this.state.attributeValues,
    };

    // Prepare payload for API
    const payload = {
      hotel_menu_id: this.props.match.params.id,  // menu id from URL
      hotel_id: this.props.selectedHotelId.id,               // Pass hotel_id from props (you should already have it)
      attribute_id: newAttribute.id,              // Using timestamp as unique id (can be replaced with backend generated ID later)
      attribute_name: newAttribute.name,
      attribute_value: newAttribute.values,
    };

    this.setState({ loading: true });

    try {
      const { status, message } = await API(this, "post", URL_PATH.addSingleAttribute, payload);  // You’ll need to define this API URL
      if (status) {
        this.showToast("Attribute added successfully", "success");
        this.setState((prevState) => ({
          attributes: [...prevState.attributes, newAttribute],
          newAttributeName: "",
          attributeValues: [],
        }));
      } else {
        this.showToast(message || "Failed to add attribute", "error");
      }
    } catch (error) {
      this.showToast("Error while adding attribute", "error");
    }

    this.setState({ loading: false });
  };

  // Add attribute
  // handleAddAttribute = () => {

  //   // this.setState({ loading: true });
  //   // console.log("this.state.attributeValues", this.state.attributeValues)
  //   // const payload = {
  //   //   product_id: this.props.match.params.id,
  //   //   attribute_data: this.prepareAttributePayload(),
  //   // };

  //   // try {
  //   //   const { status, message } = API(this, "post", URL_PATH.saveAttributes, payload);
  //   //   if (status) {
  //   //     this.showToast("Attributes saved successfully", "success");
  //   //     this.fetchAttributes(); // Optional: Refresh data
  //   //   } else {
  //   //     this.showToast(message || "Failed to save attributes", "error");
  //   //   }
  //   // } catch (error) {
  //   //   this.showToast("Error while saving attributes", "error");
  //   // }

  //   // this.setState({ loading: false });
  //   if (this.state.newAttributeName.trim() === "" ) {
  //     this.showToast("Attribute name and at least one value are required", "error")
  //     return
  //   }

  //   const newAttribute = {
  //     id: Date.now().toString(),
  //     name: this.state.newAttributeName,
  //     values: this.state.attributeValues,
  //     visible: true,
  //     used_for_variations: true,
  //   }

  //   this.setState((prevState) => ({
  //     attributes: [...prevState.attributes, newAttribute],
  //     newAttributeName: "",
  //     attributeValues: [],
  //   }))
  // }

  // Edit attribute
  handleEditAttribute = (id) => {
    const attribute = this.state.attributes.find((attr) => attr.id === id)
    if (attribute) {
      this.setState({
        editingAttributeId: id,
        newAttributeName: attribute.name,
        attributeValues: [...attribute.values],
      })
    }
  }



  saveEditedAttribute = async () => {
    if (this.state.newAttributeName.trim() === "" || this.state.attributeValues.length === 0) {
      this.showToast("Attribute name and at least one value are required", "error");
      return;
    }

    this.setState({ loading: true });

    const payload = {
      hotel_menu_id: this.props.match.params.id, // or use correct prop/state if different
      hotel_id: this.props.selectedHotelId.id, // make sure hotel_id is available via props or state
      attribute_id: this.state.editingAttributeId,
      attribute_name: this.state.newAttributeName,
      attribute_value: this.state.attributeValues,
    };

    try {
      const { status, message } = await API(this, "post", URL_PATH.saveAttributes, payload);
      if (status) {
        this.showToast("Attribute updated successfully", "success");
        this.fetchAttributes(); // Refresh attributes list
      } else {
        this.showToast(message || "Failed to update attribute", "error");
      }
    } catch (error) {
      this.showToast("Error while updating attribute", "error");
    }

    this.setState({
      editingAttributeId: null,
      newAttributeName: "",
      attributeValues: [],
      loading: false,
    });


    // if (this.state.newAttributeName.trim() === "" || this.state.attributeValues.length === 0) {
    //   this.showToast("Attribute name and at least one value are required", "error")
    //   return
    // }

    // this.setState((prevState) => ({
    //   attributes: prevState.attributes.map((attr) =>
    //     attr.id === prevState.editingAttributeId
    //       ? { ...attr, name: prevState.newAttributeName, values: prevState.attributeValues }
    //       : attr,
    //   ),
    //   editingAttributeId: null,
    //   newAttributeName: "",
    //   attributeValues: [],
    // }))
  }

  // Cancel editing
  cancelEditAttribute = () => {
    this.setState({
      editingAttributeId: null,
      newAttributeName: "",
      attributeValues: [],
    })
  }

  // Remove attribute
  handleRemoveAttribute = async (id) => {
    const payload = {
      attribute_id: id,
      hotel_menu_id: this.props.match.params.id, // or get from relevant props/state
      hotel_id: this.props.selectedHotelId.id, // make sure hotel_id is available in props or state
    };

    this.setState({ loading: true });

    try {
      const { status, message } = await API(this, "post", URL_PATH.deleteAttribute, payload);

      if (status) {
        this.showToast("Attribute deleted successfully", "success");
        this.setState((prevState) => ({
          attributes: prevState.attributes.filter((attr) => attr.id !== id),
        }));
      } else {
        this.showToast(message || "Failed to delete attribute", "error");
      }
    } catch (error) {
      this.showToast("Error while deleting attribute", "error");
    }

    this.setState({ loading: false });
  };


  // Save attributes
  saveAttributes = async () => {
    try {
      this.setState({ loading: true })

      // Format the attributes as expected by the API
      const formattedAttributes = this.state.attributes.map((attr) => ({
        attribute_id: attr.id,
        attribute_name: attr.name,
        attribute_value: attr.values,
      }))

      const payload = {
        hotel_menu_id: this.props.match.params.id,
        hotel_id: this.props.selectedHotelId.id,
        menu_attributes: formattedAttributes,
      }

      const { status, message } = await API(this, "post", `${root_url}/api/hotelowner/hotel-menu/attribute/store`, payload)

      if (status === "success") {
        this.showToast("Attributes saved successfully", "success")
        // Move to next tab
        this.setState({ activeTab: 3 }, () => {
          this.fetchVariations()
        })
      } else {
        this.showToast(message || "Failed to save attributes", "error")
      }

      this.setState({ loading: false })
    } catch (error) {
      this.showToast("Failed to save attributes", "error")
      this.setState({ loading: false })
    }
  }

  // VARIATIONS FUNCTIONS

  // Fetch variations
  fetchVariations = async () => {
    try {
      const requestData = {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
      }

      const { status, message, variations } = await API(this, "post", URL_PATH.getVariations, requestData)
      if (status === "success") {
        this.setState({
          variations: variations.map((item) => ({
            id: item.variations_id,
            price: item.variations_regular_price || "0.0",
            salePrice: item.variations_sale_price || "0.0",
            variationData: item.variations_data || [],
          })),
        })
      } else {
        // this.showToast(message, "error")
      }
    } catch (error) {
      this.showToast("Failed to fetch variations", "error")
    }
  }

  // Generate variations
  handleGenerateVariations = async () => {
    try {
      this.setState({ loading: true })

      // Format the attributes as expected by the API
      const formattedAttributes = this.state.attributes.map((attr) => ({
        attribute_id: attr.id,
        attribute_name: attr.name,
        attribute_value: attr.values,
      }))

      const payload = {
        hotel_menu_id: this.props.match.params.id,
        hotel_id: this.props.selectedHotelId.id,
        menu_attributes: formattedAttributes,
      }

      const { status, message, data } = await API(this, "post", `${root_url}/api/hotelowner/hotel-menu/variation/get`, payload)

      if (status === "success") {
        this.setState({
          variations: data.map((item) => ({
            id: item.variations_id,
            price: item.variations_regular_price || "0.0",
            salePrice: item.variations_sale_price || "0.0",
            variationData: item.variations_data || [],
          })),
        })

        this.showToast("Variations generated successfully", "success")
      } else {
        this.showToast(message || "Failed to generate variations", "error")
      }

      this.setState({ loading: false })
    } catch (error) {
      this.showToast("Failed to generate variations", "error")
      this.setState({ loading: false })
    }
  }

  // Remove variation
  handleRemoveVariation = async (id) => {
    try {
      const { status, message } = await API(this, "post", URL_PATH.removeVariation, {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        variations_id: id,
      })

      if (status === "success") {
        this.setState((prevState) => ({
          variations: prevState.variations.filter((v) => v.id !== id),
        }))
        this.showToast(message, "success")
      } else {
        this.showToast(message, "error")
      }
    } catch (error) {
      this.showToast("Failed to remove variation", "error")
    }
  }

  // Update variation price
  // handleUpdateVariationPrice = async (variationId) => {
  //   try {
  //     const variation = this.state.variations.find((v) => v.id === variationId)
  //     if (!variation) return

  //     const { status, message } = await API(this, "post", URL_PATH.updateVariationPrice, {
  //       variations_id: variationId,
  //       hotel_id: this.props.selectedHotelId.id,
  //       hotel_menu_id: this.props.match.params.id,
  //       variations_regular_price: variation.price || "0.0",
  //       variations_sale_price: variation.salePrice || "0.0",
  //     })


  //     if (status !== "success") {
  //       this.showToast(message, "error")
  //     }
  //   } catch (error) {
  //     this.showToast("Failed to update variation price", "error")
  //   }
  // }
  handleUpdateVariationPrice = async (variationId) => {
    try {
      const variation = this.state.variations.find((v) => v.id === variationId)
      if (!variation) return

      const response = await API(this, "post", URL_PATH.updateVariationPrice, {
        variations_id: variationId,
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        variations_regular_price: variation.price || "0.0",
        variations_sale_price: variation.salePrice || "0.0",
      })

      const { status, message, errors } = response

      if (status !== "success") {
        // Default message fallback
        console.log("", status)
        let errorMessage = message || "Sale price should be smaller than regular price"

        // If there are validation errors, get the first one
        if (errors && typeof errors === "object") {
          const firstErrorKey = Object.keys(errors)[0]
          if (errors[firstErrorKey] && errors[firstErrorKey].length > 0) {
            errorMessage = errors[firstErrorKey][0]
          }
        }

        this.showToast(errorMessage, "error")
      }

    } catch (error) {
      this.showToast("Failed to update variation price", "error")
    }
  }

  // Handle variation change
  handleVariationChange = (id, field, value) => {
    this.setState((prevState) => ({
      variations: prevState.variations.map((v) => {
        if (v.id === id) {
          return { ...v, [field]: value }
        }
        return v
      }),
    }))
  }

  // ADDONS FUNCTIONS

  // Fetch addons
  fetchAddons = async () => {
    try {
      const { status, message, data } = await API(this, "get", URL_PATH.getAddons(this.props.match.params.id))

      if (status === "success") {
        this.setState({ addOnGroups: data })
      } else {
        this.showToast(message, "error")
      }
    } catch (error) {
      // this.showToast("Failed to fetch addons", "error")
    }
  }

  // Add addon group
  handleAddGroup = async () => {
    try {
      this.setState({ loading: true })

      const { status, message, data } = await API(this, "post", URL_PATH.addAddonGroup, {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        ...this.state.newGroup,
      })

      if (status === "success") {
        this.setState((prevState) => ({
          addOnGroups: [
            ...prevState.addOnGroups,
            {
              id: data.id,
              ...prevState.newGroup,
              add_ons: [],
            },
          ],
          newGroup: {
            name: "",
            required: false,
            multiple: false,
            min_select: 0,
            max_select: 1,
            status: true,
          },
          isAddGroupOpen: false,
        }))

        this.showToast("Add-on group added successfully", "success")
      } else {
        this.showToast(message, "error")
      }

      this.setState({ loading: false })
    } catch (error) {
      this.showToast("Failed to add group", "error")
      this.setState({ loading: false })
    }
  }

  // Add addon item
  handleAddItem = async () => {
    if (!this.state.currentGroupId) return

    try {
      this.setState({ loading: true })

      const { status, message, data } = await API(this, "post", URL_PATH.addAddonItem, {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        group_id: this.state.currentGroupId,
        ...this.state.newAddOn,
      })

      if (status === "success") {
        this.setState((prevState) => ({
          addOnGroups: prevState.addOnGroups.map((group) => {
            if (group.id === prevState.currentGroupId) {
              return {
                ...group,
                add_ons: [
                  ...group.add_ons,
                  {
                    id: data.id,
                    ...prevState.newAddOn,
                  },
                ],
              }
            }
            return group
          }),
          newAddOn: {
            name: "",
            price: "",
            status: true,
          },
          isAddItemOpen: false,
        }))

        this.showToast("Add-on item added successfully", "success")
      } else {
        this.showToast(message, "error")
      }

      this.setState({ loading: false })
    } catch (error) {
      this.showToast("Failed to add item", "error")
      this.setState({ loading: false })
    }
  }

  // Remove addon group
  handleRemoveGroup = async (groupId) => {
    try {
      const { status, message } = await API(this, "post", URL_PATH.removeAddonGroup, {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        group_id: groupId,
      })

      if (status === "success") {
        this.setState((prevState) => ({
          addOnGroups: prevState.addOnGroups.filter((group) => group.id !== groupId),
        }))
        this.showToast("Add-on group removed successfully", "success")
      } else {
        this.showToast(message, "error")
      }
    } catch (error) {
      this.showToast("Failed to remove group", "error")
    }
  }

  // Remove addon item
  handleRemoveItem = async (groupId, itemId) => {
    try {
      const { status, message } = await API(this, "post", URL_PATH.removeAddonItem, {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        group_id: groupId,
        item_id: itemId,
      })

      if (status === "success") {
        this.setState((prevState) => ({
          addOnGroups: prevState.addOnGroups.map((group) => {
            if (group.id === groupId) {
              return {
                ...group,
                add_ons: group.add_ons.filter((item) => item.id !== itemId),
              }
            }
            return group
          }),
        }))

        this.showToast("Add-on item removed successfully", "success")
      } else {
        this.showToast(message, "error")
      }
    } catch (error) {
      this.showToast("Failed to remove item", "error")
    }
  }

  // Toggle addon group status
  handleToggleGroupStatus = async (groupId, checked) => {
    try {
      const { status, message } = await API(this, "post", URL_PATH.updateAddonGroupStatus, {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        group_id: groupId,
        status: checked,
      })

      if (status === "success") {
        this.setState((prevState) => ({
          addOnGroups: prevState.addOnGroups.map((group) => {
            if (group.id === groupId) {
              return {
                ...group,
                status: checked,
              }
            }
            return group
          }),
        }))
      } else {
        this.showToast(message, "error")
      }
    } catch (error) {
      this.showToast("Failed to update group status", "error")
    }
  }

  // Toggle addon item status
  handleToggleItemStatus = async (groupId, itemId, checked) => {
    try {
      const { status, message } = await API(this, "post", URL_PATH.updateAddonItemStatus, {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.props.match.params.id,
        group_id: groupId,
        item_id: itemId,
        status: checked,
      })

      if (status === "success") {
        this.setState((prevState) => ({
          addOnGroups: prevState.addOnGroups.map((group) => {
            if (group.id === groupId) {
              return {
                ...group,
                add_ons: group.add_ons.map((item) => {
                  if (item.id === itemId) {
                    return {
                      ...item,
                      status: checked,
                    }
                  }
                  return item
                }),
              } 
            }
            return group
          }),
        }))
      } else {
        this.showToast(message, "error")
      }
    } catch (error) {
      this.showToast("Failed to update item status", "error")
    }
  }

  // Save addons and complete the update process
  saveAddons = async () => {
    try {
      this.showToast("Menu update completed successfully", "success")
      // Navigate to menu list page
      setTimeout(() => {
        this.props.history.push(routes.admin.menu.list)
      }, 2000)
    } catch (error) {
      this.showToast("Failed to complete the update process", "error")
    }
  }

  render() { 
    const { loading } = this.state

    return (
      <Container maxWidth="lg" className="py-5">
        <Box sx={{ borderRadius: "10px", p: 3, border: "1px solid #FFC857" }}>
          <CardHeader
            title={
              <Header title="Update Menu Item" />

            }

          />
          <Tabs
            value={this.state.activeTab}
            onChange={this.handleTabChange}
            textColor="inherit"
            indicatorColor="primary"
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: "#FFC857",
              },
              "& .MuiTab-root": {
                color: "rgba(255, 255, 255, 0.7)",
                "&.Mui-selected": {
                  color: "#FFC857",
                },
              },
            }}
          >
            <Tab label="Item Description" />

            <Tab label="Space Wise Menu" />
            <Tab label="Attributes" />
            <Tab label="Variations" />
            <Tab label="Addons" />
            <Tab label="Nutrients" />
          </Tabs>

          <CardContent>
            {/* Item Description Tab */}
            {this.state.activeTab === 0 && (
              <CardContent>
                <form
                  id="hotelForm"
                  name="hotelForm"
                  onSubmit={(e) => {
                    e.preventDefault()
                    return this.update()
                  }}
                >
                  <Box mb={3}>
                    <TextField
                      fullWidth
                      id="id"
                      name="id"
                      label="ID"
                      value={this.state.id}
                      disabled
                      variant="outlined"
                      sx={{
                        backgroundColor: "#02111B",
                        color: "#FFC857",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(255, 255, 255, 0.23)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                      }}
                    />
                  </Box>
                  <Box mb={3}>
                    <TextField
                      fullWidth
                      id="brand_name"
                      name="brand_name"
                      label="Brand Name"
                      value={this.state.brand_name}
                      onChange={(e) => this.setState({ brand_name: e.target.value })}

                      placeholder="Enter Brand Name"
                      variant="outlined"
                      sx={{
                        backgroundColor: "#02111B",
                        color: "#FFC857",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(255, 255, 255, 0.23)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                      }}
                    />

                  </Box>

                  <Box mb={3}>
                    <TextField
                      fullWidth
                      id="menu_name"
                      name="menu_name"
                      label="Menu Name"
                      value={this.state.menu_name}
                      onChange={(e) => this.setState({ menu_name: e.target.value })}
                      variant="outlined"
                      required
                      sx={{
                        backgroundColor: "#02111B",
                        color: "#FFC857",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(255, 255, 255, 0.23)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                      }}
                    />
                  </Box>

                  <Box mb={3}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend" focused={false} >
                        Menu Type
                      </FormLabel>
                      <RadioGroup
                        aria-label="menu-type"
                        name="menu_type"
                        value={this.state.menu_type}
                        onChange={(e) => this.setState({ menu_type: e.target.value })}
                        row
                      >
                        <FormControlLabel
                          value="veg"
                          control={
                            <Radio
                              sx={{
                                color: "#FFC857",
                                "&.Mui-checked": {
                                  color: "#FFC857",
                                },
                              }}
                            />
                          }

                          label={
                            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <img src={Veg} alt="Veg icon" width="20" height="20" />
                              Veg
                            </span>
                          }
                          sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                        />
                        <FormControlLabel
                          value="nonveg"
                          control={
                            <Radio
                              sx={{
                                color: "#FFC857",
                                "&.Mui-checked": {
                                  color: "#FFC857",
                                },
                              }}
                            />
                          }
                          label={
                            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <img src={NonVeg} alt="Non-Veg icon" width="20" height="20" />
                              Non-Veg
                            </span>
                          }
                          sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                        />
                        <FormControlLabel
                          value="jain"
                          control={
                            <Radio
                              sx={{
                                color: "#FFC857",
                                "&.Mui-checked": {
                                  color: "#FFC857",
                                },
                              }}
                            />
                          }
                          label={
                            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <img src={Jain} alt="Jain icon" width="20" height="20" />
                              Jain
                            </span>
                          }
                          sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                        />
                        <FormControlLabel
                          value="egg"
                          control={
                            <Radio
                              sx={{
                                color: "#FFC857",
                                "&.Mui-checked": {
                                  color: "#FFC857",
                                },
                              }}
                            />
                          }
                          label={
                            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <img src={EggFood} alt="EggFood icon" width="20" height="20" />
                              EggFood
                            </span>
                          }
                          sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                        />
                        <FormControlLabel
                          value="drinks"
                          control={
                            <Radio
                              sx={{
                                color: "#FFC857",
                                "&.Mui-checked": {
                                  color: "#FFC857",
                                },
                              }}
                            />
                          }
                          label={
                            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <img src={Drinks} alt="Drink icon" width="20" height="20" />

                              Drinks
                            </span>
                          }
                        />
                      </RadioGroup>


                    </FormControl>
                  </Box>

                  <Box mb={3}>
                    <TextField
                      fullWidth
                      id="menu_price"
                      name="menu_price"
                      label="Price"
                      type="number"
                      value={this.state.menu_price}
                      onChange={(e) => {
                        this.setState({
                          menu_price: e.target.value,
                          basePrice: Number.parseFloat(e.target.value) || 0,
                        })
                      }}
                      variant="outlined"
                      required
                      sx={{
                        backgroundColor: "#02111B",
                        color: "#FFC857",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(255, 255, 255, 0.23)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                      }}
                    />
                  </Box>

                  <Box mb={3}>
                    <TextField
                      fullWidth
                      id="menu_description"
                      name="menu_description"
                      label="Menu Description"
                      value={this.state.menu_description}
                      onChange={(e) => this.setState({ menu_description: e.target.value })}
                      variant="outlined"
                      multiline
                      rows={3}
                      sx={{
                        backgroundColor: "#02111B",
                        color: "#FFC857",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(255, 255, 255, 0.23)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#FFC857",
                        },
                      }}
                    />
                  </Box>

                  <Box mb={3}>
                    <FormLabel>Category</FormLabel>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      value={this.state.category_ids || []}
                      isMulti
                      onChange={(selectedOptions) => {
                        this.setState({
                          category_ids: selectedOptions,
                        });
                      }}
                      options={this.state.category.filter(
                        cat => !this.state.category_ids?.some(selected => selected.value === cat.value)
                      )}
                      defaultValue={this.state.data?.hotel_menu_category?.map(cat => ({
                        value: cat.id,
                        label: cat.category_name
                      })) || []}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 4,
                        colors: {
                          ...theme.colors,
                          primary25: "#041A29",
                          neutral0: "#02111B",
                        },
                      })}
                      styles={{
                        control: (base) => ({
                          ...base,
                          padding: "4px",
                          backgroundColor: "#02111B",
                          borderColor: "rgba(255, 255, 255, 0.23)",
                          "&:hover": {
                            borderColor: "#FFC857",
                          },
                        }),
                        menu: (base) => ({
                          ...base,
                          backgroundColor: "#02111B",
                          zIndex: 9999,
                        }),
                        menuList: (base) => ({
                          ...base,
                          backgroundColor: "#02111B",
                          ...scrollbarHide,
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isFocused ? "#041A29" : "rgba(7, 7, 7, 0.23)",
                          "&:hover": {
                            backgroundColor: "#041A29",
                          },
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: "rgba(61, 55, 55, 0.2)",
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: "#FFC857",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          color: "#FFC857",
                          "&:hover": {
                            backgroundColor: "rgba(255, 200, 87, 0.4)",
                            color: "#FFC857",
                          },
                        }),
                      }}
                    />
                  </Box>

                  <Box mb={3}>
                    <FormLabel sx={{ mb: 1, display: "block" }}>Menu Image</FormLabel>
                    <Box
                      sx={{
                        mt: 1,
                        border: "1px dashed rgba(255, 255, 255, 0.23)",
                        borderRadius: "8px",
                        p: 3,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="file"
                        id="menu_image"
                        name="menu_image"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={this.handleImageUpload}
                      />
                      {this.state.menu_image ? (
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <img
                            src={this.state.menu_image || "/placeholder.svg"}
                            alt="Menu"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                          />
                          <IconButton onClick={this.handleImageDelete} size="small" sx={{ color: "#BB0A21" }}>
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      ) : (
                        <label htmlFor="menu_image" style={{ cursor: "pointer" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 1,
                              color: "rgba(255, 255, 255, 0.7)",
                            }}
                          >
                            <Box
                              sx={{
                                width: "40px",
                                height: "40px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px dashed rgba(255, 255, 255, 0.23)",
                                borderRadius: "4px",
                                mb: 1,
                              }}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                              </svg>
                            </Box>
                            <Typography>Upload a file</Typography>
                            <Typography variant="caption" color="text.secondary">
                              PNG, JPG, GIF up to 1.0MB
                            </Typography>
                          </Box>
                        </label>
                      )}
                    </Box>
                  </Box>
                  <Box mb={3}>
                    <FormControl component="fieldset" fullWidth>
                      <FormLabel component="legend" focused={false}>
                        Food Available
                      </FormLabel>
                      <RadioGroup
                        aria-label="food-available"
                        name="menu_available_time_slot"
                        value={this.state.menu_available_time_slot}
                        onChange={this.handleFoodAvailableChange}
                        row
                      >
                        <FormControlLabel
                          value="allday"
                          control={
                            <Radio
                              sx={{
                                color: "#FFC857",
                                "&.Mui-checked": {
                                  color: "#FFC857",
                                },
                              }}
                            />
                          }
                          label="All Day"
                        />
                        <FormControlLabel
                          value="multiple"
                          control={
                            <Radio
                              sx={{
                                color: "#FFC857",
                                "&.Mui-checked": {
                                  color: "#FFC857",
                                },
                              }}
                            />
                          }
                          label="Slot Wise"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>

                  {this.state.menu_available_time_slot === "multiple" && (
                    <Box mb={3}>
                      {/* Time slot inputs */}
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="start-time-label">Start Time</InputLabel>
                        <MuiSelect
                          labelId="start-time-label"
                          id="start_time"
                          name="start_time"
                          value={this.state.currentStartTime}
                          label="Start Time"
                          onChange={(e) => this.setState({ currentStartTime: e.target.value })}
                          sx={{ backgroundColor: "#02111B", color: "#fff" }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                ...scrollbarHide,
                                backgroundColor: "#02111B",
                                color: "#fff",
                                "& .MuiMenuItem-root": {
                                  color: "#fff",
                                  "&:hover": {
                                    backgroundColor: "#041A29",
                                  },
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem value="">Select</MenuItem>
                          {this.getSlots().map((slot) => (
                            <MenuItem key={slot.value} value={slot.value}>
                              {slot.label}
                            </MenuItem>
                          ))}
                        </MuiSelect>
                      </FormControl>

                      {this.state.currentStartTime && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <InputLabel id="end-time-label">End Time</InputLabel>
                          <MuiSelect
                            labelId="end-time-label"
                            id="end_time"
                            name="end_time"
                            value={this.state.currentEndTime}
                            label="End Time"
                            onChange={(e) => this.setState({ currentEndTime: e.target.value })}
                            sx={{ backgroundColor: "#02111B", color: "#fff" }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  ...scrollbarHide,
                                  backgroundColor: "#02111B",
                                  color: "#fff",
                                  "& .MuiMenuItem-root": {
                                    color: "#fff",
                                    "&:hover": {
                                      backgroundColor: "#041A29",
                                    },
                                  },
                                },
                              },
                            }}
                          >
                            <MenuItem value="">Select</MenuItem>
                            {this.getSlots(this.state.currentStartTime).map((slot) => (
                              <MenuItem key={slot.value} value={slot.value}>
                                {slot.label}
                              </MenuItem>
                            ))}
                          </MuiSelect>
                        </FormControl>
                      )}

                      {/* Add Slot button */}
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={!this.state.currentStartTime || !this.state.currentEndTime}
                        onClick={this.addTimeSlot}
                        sx={{ mt: 2 }}
                      >
                        Add Time Slot
                      </Button>

                      {/* Display added slots */}
                      {this.state.timeSlots.length > 0 && (
                        <Box mt={2}>
                          <Typography variant="subtitle1">Time Slots:</Typography>
                          <List>
                            {this.state.timeSlots.map((slot, index) => (
                              <ListItem key={index}>
                                <ListItemText
                                  primary={`${slot.display_start} to ${slot.display_end}`}
                                />
                                <IconButton
                                  edge="end"
                                  onClick={() => this.removeTimeSlot(index)}
                                  color="error"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </ListItem>
                            ))}
                          </List>
                        </Box>
                      )}
                    </Box>
                  )}

                  {/* {this.state.menu_available_time_slot === "multiple" && (
                        <Box mb={3}>
                          <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="start-time-label">Start Time</InputLabel>
                            <MuiSelect
                              labelId="start-time-label"
                              id="start_time"
                              name="start_time"
                              value={this.state.start_time}
                              label="Start Time"
                              onChange={this.handleStartTimeChange}
                              sx={{ backgroundColor: "#02111B", color: "#fff" }}
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    ...scrollbarHide,
                                    backgroundColor: "#02111B",
                                    backgroundImage: "none",
                                    color: "#fff",
                                    "& .MuiMenuItem-root": {
                                      color: "#fff",
                                      "&:hover": {
                                        backgroundColor: "#041A29",
                                      },
                                    },
                                  },
                                },
                              }}
                            >
                              <MenuItem value="">Select</MenuItem>
                              {this.getSlots().map((slot) => (
                                <MenuItem key={slot.value} value={slot.value}>
                                  {slot.label}
                                </MenuItem>
                              ))}
                            </MuiSelect>
                          </FormControl>

                          {this.state.start_time !== "" && (
                            <FormControl fullWidth>
                              <InputLabel id="end-time-label">End Time</InputLabel>
                              <MuiSelect
                                labelId="end-time-label"
                                id="end_time"
                                name="end_time"
                                value={this.state.end_time}
                                label="End Time"
                                onChange={this.handleEndTimeChange}
                                sx={{ backgroundColor: "#02111B", color: "#fff" }}
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      ...scrollbarHide,
                                      backgroundColor: "#02111B",
                                      color: "#fff",
                                      "& .MuiMenuItem-root": {
                                        color: "#fff",
                                        "&:hover": {
                                          backgroundColor: "#041A29",
                                        },
                                      },
                                    },
                                  },
                                }}
                              >
                                <MenuItem value="">Select</MenuItem>
                                {this.getSlots(this.state.start_time).map((slot) => (
                                  <MenuItem key={slot.value} value={slot.value}>
                                    {slot.label}
                                  </MenuItem>
                                ))}
                              </MuiSelect>
                            </FormControl>
                          )}
                        </Box>
                      )} */}

                  <Box mb={3}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.status}
                          onChange={(e) => this.setState({ status: e.target.checked })}
                        // sx={{
                        //   "& .MuiSwitch-switchBase.Mui-checked": {
                        //     color: "#FFC857",
                        //     "&:hover": {
                        //       backgroundColor: "rgba(255, 200, 87, 0.08)",
                        //     },
                        //   },
                        //   "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                        //     backgroundColor: "#FFC857",
                        //   },
                        // }}
                        />
                      }
                      label="Status"
                      sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                    />
                  </Box>

                  <Box mt={4} display="flex" justifyContent="flex-start">
                    {/* UPDATE & NEXT Button */}
                    {/* UPDATE & NEXT Button */}
                    <Button
                      variant="contained"
                      type="submit"
                      size="large"
                      disabled={this.state.updateAndNextLoading || this.state.updateLoading}
                      sx={{
                        px: 4,
                        py: 1,
                        borderRadius: 1,
                        textTransform: "none",
                        fontWeight: 700,
                        bgcolor: "#FFC857",
                        color: "#000",
                        "&:hover": { bgcolor: "#E6B54E" },
                        marginRight: 2
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        this.update(true);
                      }}
                    >
                      {this.state.updateAndNextLoading ? (
                        <>
                          <span
                            style={{
                              display: "inline-block",
                              animation: "spin 1s linear infinite",
                              marginRight: "8px",
                            }}
                          >
                            ⟳
                          </span>
                          Updating...
                        </>
                      ) : (
                        "UPDATE & NEXT"
                      )}
                    </Button>

                    {/* UPDATE Button */}
                    <Button
                      variant="contained"
                      type="submit"
                      size="large"
                      disabled={this.state.updateLoading || this.state.updateAndNextLoading}
                      sx={{
                        px: 4,
                        py: 1,
                        borderRadius: 1,
                        textTransform: "none",
                        fontWeight: 700,
                        bgcolor: "#FFC857",
                        color: "#000",
                        "&:hover": { bgcolor: "#E6B54E" },
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        this.updateSave(false);
                      }}
                    >
                      {this.state.updateLoading ? (
                        <>
                          <span
                            style={{
                              display: "inline-block",
                              animation: "spin 1s linear infinite",
                              marginRight: "8px",
                            }}
                          >
                            ⟳
                          </span>
                          Updating...
                        </>
                      ) : (
                        "UPDATE"
                      )}
                    </Button>
                  </Box>
                </form>
              </CardContent>
            )}
            {this.state.activeTab === 5 && (
              <CardContent>
                <NutriationTab
                  hotelId={this.props.selectedHotelId.id}
                  menuId={this.props.match.params.id}
                  openModal={this.showToast}
                  onSuccess={this.handleNutritionSuccess}
                />
              </CardContent>
            )}
            {/* Space Wise Menu Tab */}
            {this.state.activeTab === 1 && (
              <div style={{ padding: '16px' }}>
                {this.state.spaceData?.length > 0 ? (
                  <div>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                      gap: '24px',
                      marginBottom: '32px'
                    }}>
                      {this.state.spaceData.map((space, index) => (
                        <div key={index} style={{
                          background: '#041A29',
                          borderRadius: '8px',
                          padding: '24px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                        }}>
                          {/* Header */}
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px'
                          }}>
                            <h3 style={{
                              margin: 0,
                              fontSize: '18px',
                              fontWeight: '500',
                              color: 'white'
                            }}>
                              {space.area_name}
                            </h3>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Switch
                                checked={space.area_status}
                                onChange={(e) => this.handleStatusChange(index, e.target.checked)}

                              />
                              <div style={{ fontSize: '14px', color: space.area_status ? '#4CAF50' : '#AEB6BF' }}>
                                {space.area_status ? "Active" : "Inactive"}
                              </div>
                            </div>
                          </div>

                          {/* Inputs */}
                          <div style={{ display: 'grid', gap: '16px' }}>
                            {/* Price Type */}
                            <FormControl fullWidth variant="outlined">
                              <FormLabel sx={{ color: "#D5D8DC", fontSize: "13px", mb: 1, fontWeight: 500 }}>
                                Price Type
                              </FormLabel>
                              <MUISelect
                                value={space.area_price_type}
                                onChange={(e) => this.handlePriceTypeChange(index, e.target.value)}
                                sx={{
                                  backgroundColor: '#02111B',
                                  color: '#EAEDED',
                                  borderRadius: '6px',
                                  fontSize: '14px',
                                  '.MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#1C2833'
                                  },
                                  '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#FFC857'
                                  }
                                }}
                              >
                                <MenuItem value="fix" sx={{ backgroundColor: '#02111B', color: '#EAEDED' }}>
                                  Fixed Amount
                                </MenuItem>
                                <MenuItem value="percentage" sx={{ backgroundColor: '#02111B', color: '#EAEDED' }}>
                                  Percentage
                                </MenuItem>
                              </MUISelect>
                            </FormControl>

                            {/* Price Value */}
                            <div>
                              <label style={{
                                display: 'block',
                                marginBottom: '6px',
                                fontSize: '13px',
                                color: '#D5D8DC',
                                fontWeight: '500'
                              }}>
                                {space.area_price_type === "fix" ? "AMOUNT" : "PERCENTAGE"}
                              </label>
                              <div style={{ position: 'relative' }}>
                                <TextField
                                  type="number"
                                  value={space.area_type_wise_value}
                                  onChange={(e) => this.handlePriceValueChange(index, e.target.value)}
                                  fullWidth
                                  sx={{
                                    backgroundColor: '#02111B',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    color: '#EAEDED',
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: '#1C2833',
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                      borderColor: '#FFC857',
                                    }
                                  }}
                                  InputProps={{
                                    endAdornment: space.area_price_type === "percentage" ? (
                                      <InputAdornment position="end">%</InputAdornment>
                                    ) : null,
                                  }}
                                />
                              </div>
                            </div>

                            {/* Final Price */}
                            <div>
                              <label style={{
                                display: 'block',
                                marginBottom: '6px',
                                fontSize: '13px',
                                color: '#D5D8DC',
                                fontWeight: '500'
                              }}>
                                FINAL PRICE
                              </label>
                              <div style={{ position: 'relative' }}>
                                <TextField
                                  type="text"
                                  value={space.area_final_price}
                                  fullWidth
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                    readOnly: true,
                                  }}
                                  sx={{
                                    backgroundColor: '#02111B',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    color: '#EAEDED',
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: '#1C2833',
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Save Button */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      padding: '16px 0',
                    }}>
                      <Button
                        variant="contained"

                        onClick={(e) => {
                          this.handleSaveSpaces(e).then(() => {
                            this.setState({ activeTab: 2 })
                          })
                        }}
                        // disabled={loading}
                        sx={{
                          backgroundColor: '#FFC857',
                          color: 'black',
                          borderRadius: '6px',
                          padding: '10px 24px',
                          fontSize: '14px',
                          fontWeight: '700',
                          textTransform: 'none',
                          '&:hover': { backgroundColor: '#E6B54E' }
                        }}
                      >
                        
                     
                          UPDATE & NEXT
                          
                       
                      </Button>
                    </div>
                  </div>
                ) : (
                  <p style={{
                    color: '#D5D8DC',
                    fontSize: '16px',
                    marginBottom: '24px',
                    textAlign: 'center'
                  }}>
                    No spaces available
                  </p>
                )}
              </div>
            )}


            {/* Attributes Tab */}
            {this.state.activeTab === 2 && (
              <CardContent>
                <Box sx={{ mb: 3 }}>


                  {this.state.attributes.length > 0 ? (
                    <Box>
                      {this.state.attributes.map((attribute) => (
                        <Box
                          key={attribute.id}
                          sx={{
                            p: 1,
                            mb: 2,
                            backgroundColor: "#02111B",
                            border: "1px solid rgba(255, 255, 255, 0.12)",
                            borderRadius: "4px",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <Typography variant="body2" sx={{ color: "white", mb: 1 }}>
                                Name:
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                value={attribute.name}
                                disabled
                                sx={{
                                  backgroundColor: "#02111B",
                                  input: { color: "#fff" },
                                  ".MuiOutlinedInput-notchedOutline": {
                                    borderColor: "rgba(255, 255, 255, 0.23)",
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                <Box sx={{ flexGrow: 1 }}>
                                  <Typography variant="body2" sx={{ color: "white", mb: 1 }}>
                                    Value(s):
                                  </Typography>
                                  <Box
                                    sx={{
                                      minHeight: "38px",
                                      p: 1,
                                      border: "1px solid rgba(255, 255, 255, 0.23)",
                                      borderRadius: "4px",
                                      backgroundColor: "#02111B",
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {attribute.values.map((value, index) => (
                                      <Chip
                                        key={index}
                                        label={value}
                                        sx={{
                                          borderRadius: "0px",
                                          height: "24px",
                                          backgroundColor: "#041A29",
                                          color: "white",
                                        }}
                                      />
                                    ))}
                                  </Box>
                                </Box>
                                <Button
                                  variant="text"
                                  size="small"
                                  sx={{
                                    color: "white",
                                    backgroundColor: "#BB0A21",
                                    ml: 2,
                                    mt: 2,
                                    alignSelf: "center"
                                  }}
                                  onClick={() => this.handleRemoveAttribute(attribute.id)}
                                  startIcon={<DeleteIcon />}
                                >
                                  DELETE
                                </Button>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Box sx={{ textAlign: "center", py: 4, color: "rgba(255, 255, 255, 0.5)" }}>
                      <Typography>No attributes added yet.</Typography>
                    </Box>
                  )}

                  <Box sx={{ mb: 3, mt: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Name"
                          value={this.state.newAttributeName}
                          onChange={(e) => this.setState({ newAttributeName: e.target.value })}
                          placeholder="e.g., Size"
                          variant="outlined"
                          size="small"
                          sx={{
                            backgroundColor: "#02111B",
                            "& .MuiOutlinedInput-root": {
                              color: "#fff",
                              "& fieldset": {
                                borderColor: "rgba(255, 255, 255, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: "#FFC857",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#FFC857",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              color: "rgba(255, 255, 255, 0.7)",
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: "#FFC857",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <TextField
                            fullWidth
                            label="Value"
                            value={this.state.newAttributeValue}
                            onChange={(e) => this.setState({ newAttributeValue: e.target.value })}
                            onKeyPress={this.handleAttributeValueKeyPress}
                            placeholder="e.g., Small (press Enter to add)"
                            variant="outlined"
                            size="small"
                            sx={{
                              backgroundColor: "#02111B",
                              "& .MuiOutlinedInput-root": {
                                color: "#fff",
                                "& fieldset": {
                                  borderColor: "rgba(255, 255, 255, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: "#FFC857",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#FFC857",
                                },
                              },
                              "& .MuiInputLabel-root": {
                                color: "rgba(255, 255, 255, 0.7)",
                              },
                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#FFC857",
                              },
                            }}
                          />
                          <Button
                            variant="outlined"
                            onClick={this.handleAddAttributeValue}
                            sx={{
                              borderColor: "#FFC857",
                              color: "#FFC857",
                              "&:hover": {
                                borderColor: "#E6B54E",
                                backgroundColor: "#041A29",
                              },
                              height: '40px', // Match the TextField height
                              alignSelf: 'flex-end', // Align with the TextField bottom
                            }}
                          >
                            Add
                          </Button>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                            mt: 1,
                            alignItems: "center",
                          }}
                        >
                          {this.state.attributeValues.map((value, index) => (
                            <Chip
                              key={index}
                              label={value}
                              size="small"
                              onDelete={() => this.handleRemoveAttributeValue(value)}
                              sx={{
                                bgcolor: "#041A29",
                                color: "white",
                                borderRadius: "0px",
                                "& .MuiChip-deleteIcon": {
                                  color: "#BB0A21",
                                  "&:hover": {
                                    color: "#BB0A21",
                                  },
                                },
                              }}
                            />
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
                      <Button
                        variant="contained"
                        onClick={this.handleAddAttribute}
                        sx={{
                          px: 3,
                          py: 1,
                          borderRadius: 1,
                          textTransform: "none",
                          fontWeight: 700,
                          bgcolor: "#FFC857",
                          "&:hover": { bgcolor: "#E6B54E" },
                        }}
                      >
                        + Add New Attribute
                      </Button>

                    </Box>
                  </Box>

                  <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
                    <Button
                      variant="contained"
                      onClick={(e) => {

                        this.setState({ activeTab: 3 })

                      }}
                      disabled={this.state.loading}
                      sx={{
                        px: 8,
                        py: 1,
                        borderRadius: 1,
                        textTransform: "none",
                        fontWeight: 700,
                        bgcolor: "#FFC857",
                        color: "#000",
                        "&:hover": { bgcolor: "#E6B54E" },
                        "&.Mui-disabled": {
                          bgcolor: "#FFC857",
                          color: "#000",
                          opacity: 0.7
                        }
                      }}
                    >
                      {this.state.loading ? "Saving..." : "UPDATE & NEXT"}
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            )}
            {/* Variations Tab */}
            {this.state.activeTab === 3 && (
              <CardContent>
                <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                  <Button
                    variant="outlined"
                    onClick={this.handleGenerateVariations}
                    disabled={loading}
                    sx={{
                      borderColor: "#FFC857",
                      color: "white",
                      "&:hover": {
                        borderColor: "#E6B54E",
                        backgroundColor: "rgba(255, 200, 87, 0.08)",
                      },
                    }}
                  >
                    {loading ? (
                      <>
                        <span style={{ display: "inline-block", animation: "spin 1s linear infinite", marginRight: "8px" }}>
                          ⟳
                        </span>
                        Generating...
                      </>
                    ) : (
                      "Generate Variations"
                    )}
                  </Button>
                </Box>

                {this.state.variations.length > 0 ? (
                  <TableContainer component={Paper} sx={{ bgcolor: "#02111B", backgroundImage: "none", mb: 3 }}>
                    <Table
                      sx={{
                        "& .MuiTableRow-root": {
                          "&:nth-of-type(odd)": {
                            backgroundColor: "#02111B",
                          },
                          "&:nth-of-type(even)": {
                            backgroundColor: "#02111B",
                          },
                        },
                        "& .MuiTableCell-root": {
                          borderBottom: "none",
                        },
                      }}
                    >
                      <TableHead>
                        <TableRow sx={{ borderBottom: "1px solid #FFC857" }}>
                          <TableCell sx={{ color: "white", fontWeight: "bold" }}>Sr.No</TableCell>
                          <TableCell sx={{ color: "white", fontWeight: "bold" }}>Variation Data</TableCell>
                          <TableCell sx={{ color: "white", fontWeight: "bold" }}>Regular Price</TableCell>
                          <TableCell sx={{ color: "white", fontWeight: "bold" }}>Discounted Price</TableCell>
                          <TableCell align="left" sx={{ color: "white", fontWeight: "bold" }}>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.variations.map((variation, index) => (
                          <TableRow key={variation.id}>
                            <TableCell sx={{ color: "white" }}>{index + 1}</TableCell>
                            <TableCell sx={{ color: "text.primary" }}>
                              <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                                {variation.variationData.map((value, idx) => (
                                  <Typography
                                    key={idx}
                                    variant="body2"
                                    sx={{
                                      m: 0.5,

                                      display: "inline-block",
                                    }}
                                  >
                                    {value}
                                  </Typography>
                                ))}
                              </Box>
                            </TableCell>
                            <TableCell sx={{ color: "text.primary" }}>
                              <TextField
                                type="number"
                                value={variation.price}
                                onChange={(e) => this.handleVariationChange(variation.id, "price", e.target.value)}
                                onBlur={() => this.handleUpdateVariationPrice(variation.id)}
                                size="small"
                                InputProps={{
                                  startAdornment: (
                                    <Typography variant="body2" sx={{ mr: 0.5, color: "white" }}>
                                      ₹
                                    </Typography>
                                  ),
                                }}
                                sx={{
                                  width: 100,
                                  backgroundColor: "#041A29",
                                  input: { color: "#fff" },
                                  ".MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#02111B",
                                  },
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ color: "text.primary" }}>
                              <TextField
                                type="number"
                                value={variation.salePrice}
                                onChange={(e) => this.handleVariationChange(variation.id, "salePrice", e.target.value)}
                                onBlur={() => this.handleUpdateVariationPrice(variation.id)}
                                size="small"
                                InputProps={{
                                  startAdornment: (
                                    <Typography variant="body2" sx={{ mr: 0.5, color: "white" }}>
                                      ₹
                                    </Typography>
                                  ),
                                }}
                                sx={{
                                  width: 100,
                                  backgroundColor: "#041A29",
                                  input: { color: "#fff" },
                                  ".MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#02111B",
                                  },
                                }}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 1 }}>
                                <Button
                                  size="small"
                                  variant="contained"
                                  sx={{ color: "white", bgcolor: "#BB0A21", "&:hover": { bgcolor: "#D32F2F" } }}
                                  onClick={() => this.handleRemoveVariation(variation.id)}
                                  startIcon={<DeleteIcon />}
                                >
                                  DELETE
                                </Button>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <Typography variant="body1" color="text.secondary">
                      No variations yet. Click "Generate Variations" to create them from your attributes.
                    </Typography>
                  </Box>
                )}

                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    onClick={() => this.setState({ activeTab: 4 })}
                    sx={{
                      px: 3,
                      py: 1,
                      borderRadius: 1,
                      textTransform: "none",
                      fontWeight: 700,
                      bgcolor: "#FFC857",
                      color: "#000",
                      "&:hover": { bgcolor: "#E6B54E" },
                    }}
                  >
                    UPDATE & NEXT
                  </Button>
                </Box>
              </CardContent>
            )}

            {/* Add-ons Tab */}
            {this.state.activeTab === 4 && (
              <CardContent>
                {/* Use your custom fetchAddons function to load add-ons data */}
                {this.state.addOnGroups && this.state.addOnGroups.length > 0 ? (
                  <Box sx={{ mb: 4 }}>
                    {this.state.addOnGroups.map((group) => (
                      <Paper
                        key={group.id}
                        sx={{
                          mb: 4,
                          backgroundColor: "#02111B",
                          border: "1px solid rgba(255, 255, 255, 0.12)",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          sx={{
                            p: 3,
                            backgroundColor: "rgba(255, 255, 255, 0.05)",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <Typography variant="h6" sx={{ color: "#FFC857" }}>
                              {group.name}
                            </Typography>
                            <Box sx={{ display: "flex", gap: 2, mt: 0.5, color: "rgba(255, 255, 255, 0.5)" }}>
                              <Typography variant="body2">{group.is_required ? "Required" : "Optional"}</Typography>
                            </Box>
                          </Box>
                        </Box>

                        <Box sx={{ p: 3 }}>
                          {group.options && group.options.length > 0 ? (
                            <TableContainer component={Paper} sx={{ backgroundColor: "#02111B" }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell sx={{ color: "#FFC857" }}>Name</TableCell>
                                    <TableCell sx={{ color: "#FFC857" }}>Price (₹)</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {group.options.map((item) => (
                                    <TableRow key={item.id}>
                                      <TableCell sx={{ color: "rgba(255, 255, 255, 0.7)" }}>{item.name}</TableCell>
                                      <TableCell sx={{ color: "rgba(255, 255, 255, 0.7)" }}>₹{item.price}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : (
                            <Box sx={{ textAlign: "center", py: 3, color: "rgba(255, 255, 255, 0.5)" }}>
                              <Typography>No add-on items found.</Typography>
                            </Box>
                          )}
                        </Box>
                      </Paper>
                    ))}
                  </Box>
                ) : (
                  <Box sx={{ textAlign: "center", py: 6, color: "rgba(255, 255, 255, 0.5)" }}>
                    <Typography>No add-on groups found. Use the AddOnsTab component to add new add-ons.</Typography>
                  </Box>
                )}

                <AddOnsTab
                  hotelId={this.props.selectedHotelId.id}
                  menuId={this.props.match.params.id}
                  openModal={(type, title, message) => {
                    this.showToast(message, type === "error" ? "error" : "success")
                  }}
                />
              </CardContent>
            )}
          </CardContent>
        </Box>

        {/* Add Group Dialog */}
        <Dialog
          open={this.state.isAddGroupOpen}
          onClose={() => this.setState({ isAddGroupOpen: false })}
          PaperProps={{
            style: {
              backgroundColor: "#02111B",
              color: "rgba(255, 255, 255, 0.7)",
              border: "1px solid rgba(255, 255, 255, 0.12)",
            },
          }}
        >
          <DialogTitle sx={{ color: "#FFC857" }}>Add Add-on Group</DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 2, pb: 1 }}>
              <TextField
                fullWidth
                label="Group Name"
                placeholder="e.g., Extra Toppings"
                value={this.state.newGroup.name}
                onChange={(e) =>
                  this.setState({
                    newGroup: { ...this.state.newGroup, name: e.target.value },
                  })
                }
                margin="dense"
                sx={{
                  mb: 3,
                  backgroundColor: "#02111B",
                  color: "#FFC857",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(255, 255, 255, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFC857",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFC857",
                  },
                  "& .MuiInputLabel-root": {
                    color: "rgba(255, 255, 255, 0.7)",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#FFC857",
                  },
                }}
              />

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography>Required</Typography>
                <Switch
                  checked={this.state.newGroup.required}
                  onChange={(e) =>
                    this.setState({
                      newGroup: { ...this.state.newGroup, required: e.target.checked },
                    })
                  }

                />
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography>Allow Multiple Selection</Typography>
                <Switch
                  checked={this.state.newGroup.multiple}
                  onChange={(e) =>
                    this.setState({
                      newGroup: { ...this.state.newGroup, multiple: e.target.checked },
                    })
                  }
                // sx={{
                //   "& .MuiSwitch-switchBase.Mui-checked": {
                //     color: "#FFC857",
                //     "&:hover": {
                //       backgroundColor: "rgba(255, 200, 87, 0.08)",
                //     },
                //   },
                //   "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                //     backgroundColor: "#FFC857",
                //   },
                // }}
                />
              </Box>

              {this.state.newGroup.multiple && (
                <>
                  <TextField
                    fullWidth
                    label="Minimum Selection"
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    value={this.state.newGroup.min_select}
                    onChange={(e) =>
                      this.setState({
                        newGroup: { ...this.state.newGroup, min_select: Number.parseInt(e.target.value) || 0 },
                      })
                    }
                    margin="dense"
                    sx={{
                      mb: 2,
                      backgroundColor: "#02111B",
                      color: "#FFC857",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FFC857",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FFC857",
                      },
                      "& .MuiInputLabel-root": {
                        color: "rgba(255, 255, 255, 0.7)",
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: "#FFC857",
                      },
                    }}
                  />

                  <TextField
                    fullWidth
                    label="Maximum Selection"
                    type="number"
                    InputProps={{ inputProps: { min: 1 } }}
                    value={this.state.newGroup.max_select}
                    onChange={(e) =>
                      this.setState({
                        newGroup: { ...this.state.newGroup, max_select: Number.parseInt(e.target.value) || 1 },
                      })
                    }
                    margin="dense"
                    sx={{
                      mb: 2,
                      backgroundColor: "#02111B",
                      color: "#FFC857",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FFC857",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FFC857",
                      },
                      "& .MuiInputLabel-root": {
                        color: "rgba(255, 255, 255, 0.7)",
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: "#FFC857",
                      },
                    }}
                  />
                </>
              )}

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography>Active</Typography>
                <Switch
                  checked={this.state.newGroup.status}
                  onChange={(e) =>
                    this.setState({
                      newGroup: { ...this.state.newGroup, status: e.target.checked },
                    })
                  }
                // sx={{
                //   "& .MuiSwitch-switchBase.Mui-checked": {
                //     color: "#FFC857",
                //     "&:hover": {
                //       backgroundColor: "rgba(255, 200, 87, 0.08)",
                //     },
                //   },
                //   "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                //     backgroundColor: "#FFC857",
                //   },
                // }}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ isAddGroupOpen: false })} sx={{ color: "rgba(255, 255, 255, 0.7)" }}>
              Cancel
            </Button>
            <Button
              onClick={this.handleAddGroup}
              sx={{
                bgcolor: "#FFC857",
                color: "#000",
                "&:hover": { bgcolor: "#E6B54E" },
              }}
            >
              Add Group
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add Item Dialog */}
        <Dialog
          open={this.state.isAddItemOpen}
          onClose={() => this.setState({ isAddItemOpen: false })}
          PaperProps={{
            style: {
              backgroundColor: "#02111B",
              color: "rgba(255, 255, 255, 0.7)",
              border: "1px solid rgba(255, 255, 255, 0.12)",
            },
          }}
        >
          <DialogTitle sx={{ color: "#FFC857" }}>Add Add-on Item</DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 2, pb: 1 }}>
              <TextField
                fullWidth
                label="Item Name"
                placeholder="e.g., Extra Cheese"
                value={this.state.newAddOn.name}
                onChange={(e) =>
                  this.setState({
                    newAddOn: { ...this.state.newAddOn, name: e.target.value },
                  })
                }
                margin="dense"
                sx={{
                  mb: 3,
                  backgroundColor: "#02111B",
                  color: "#FFC857",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(255, 255, 255, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFC857",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFC857",
                  },
                  "& .MuiInputLabel-root": {
                    color: "rgba(255, 255, 255, 0.7)",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#FFC857",
                  },
                }}
              />

              <TextField
                fullWidth
                label="Price (₹)"
                type="number"
                placeholder="e.g., 50"
                value={this.state.newAddOn.price}
                onChange={(e) =>
                  this.setState({
                    newAddOn: { ...this.state.newAddOn, price: e.target.value },
                  })
                }
                margin="dense"
                sx={{
                  mb: 3,
                  backgroundColor: "#02111B",
                  color: "#FFC857",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(255, 255, 255, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFC857",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFC857",
                  },
                  "& .MuiInputLabel-root": {
                    color: "rgba(255, 255, 255, 0.7)",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#FFC857",
                  },
                }}
              />

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography>Active</Typography>
                <Switch
                  checked={this.state.newAddOn.status}
                  onChange={(e) =>
                    this.setState({
                      newAddOn: { ...this.state.newAddOn, status: e.target.checked },
                    })
                  }
                // sx={{
                //   "& .MuiSwitch-switchBase.Mui-checked": {
                //     color: "#FFC857",
                //     "&:hover": {
                //       backgroundColor: "rgba(255, 200, 87, 0.08)",
                //     },
                //   },
                //   "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                //     backgroundColor: "#FFC857",
                //   },
                // }}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ isAddItemOpen: false })} sx={{ color: "rgba(255, 255, 255, 0.7)" }}>
              Cancel
            </Button>
            <Button
              onClick={this.handleAddItem}
              sx={{
                bgcolor: "#FFC857",
                color: "#000",
                "&:hover": { bgcolor: "#E6B54E" },
              }}
            >
              Add Item
            </Button>
          </DialogActions>
        </Dialog>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </Container>
    )
  }
}

export default redux(UpdateMenuScreen)